// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import 'es6-promise/auto'
import axios from 'axios'

// Internal Dependencies:
import { getHostname } from 'utilities/url'

// Redux:
import { setScrollTopButtonVisibility } from 'actions/site'

const siteHostname = window.location.hostname

class PageEvents extends React.Component {
	componentDidMount() {
		const { isMobile } = this.props

		this.doUpdate()

		this.raf = window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			window.oRequestAnimationFrame
		this.lastScrollTop = ( window.pageYOffset || document.documentElement.scrollTop )
		this.subHeaderIsFixed = false

		if ( this.raf && ! isMobile ) {
			this.checkScroll()
		}
	}

	componentWillUnmount() {
		window.removeEventListener( 'click', this.handleLinkClick )
		window.removeEventListener( 'submit', this.handleFormSubmit )
		window.removeEventListener( 'click', this.handleAccordionTitleClick )
	}

	componentDidUpdate( prevProps, prevState ) {
		this.doUpdate()
	}

	checkScroll = () => {
		let scrollTop = ( window.pageYOffset || document.documentElement.scrollTop )

		if ( this.lastScrollTop === scrollTop ) {
			this.raf.call( window, this.checkScroll )

			return
		} else {
			if ( scrollTop >= 500 ) {
				this.showScrollTopButton()
			} else {
				this.hideScrollTopButton()
			}

			// if ( scrollTop > 300 && this.lastScrollTop > ( scrollTop + 25 ) ) {
			// 	// Scrolling up:
			// 	this.handleScrollUp()
			// } else if ( this.lastScrollTop < ( scrollTop - 10 ) ) {
			// 	// Scrolling down:
			// 	this.handleScrollDown()
			// }

			// if ( scrollTop >= 100 ) {
			// 	// Scrolling up:
			// 	this.setSubHeaderAsFixed()
			// } else if ( scrollTop <= 41 && 0 != scrollTop ) {
			// 	// Scrolling down:
			// 	this.setSubHeaderAsAtTop()
			// } else if ( 0 == scrollTop ) {
			// 	// Scrolling down:
			// 	this.setSubHeaderAsNotFixed()
			// }

			this.lastScrollTop = scrollTop
			this.raf.call( window, this.checkScroll )
		}
	}

	showScrollTopButton = () => {
		const { scrollTopButtonVisibility, dispatch } = this.props

		if ( ! scrollTopButtonVisibility ) {
			dispatch( setScrollTopButtonVisibility( true ) )
		}
	}

	hideScrollTopButton = () => {
		const { scrollTopButtonVisibility, dispatch } = this.props

		if ( scrollTopButtonVisibility ) {
			dispatch( setScrollTopButtonVisibility( false ) )
		}
	}

	handleScrollUp() {
		document.documentElement.classList.add( 'html-is-scrolling-up' )
	}

	handleScrollDown() {
		document.documentElement.classList.remove( 'html-is-scrolling-up' )
	}

	setSubHeaderAsFixed() {
		document.documentElement.classList.add( 'html-with-sub-header-fixed' )
		document.documentElement.classList.remove( 'html-with-sub-header-at-top' )
	}

	setSubHeaderAsAtTop() {
		document.documentElement.classList.add( 'html-with-sub-header-at-top' )
	}

	setSubHeaderAsNotFixed() {
		document.documentElement.classList.remove( 'html-with-sub-header-fixed' )
		document.documentElement.classList.remove( 'html-with-sub-header-at-top' )
	}

	doUpdate() {
		const urlParams = new URLSearchParams( window.location.search )

		// Links:
		const elements = document.querySelectorAll( '.content-body-wrap a, .content-custom-wrap a' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleLinkClick )
		})

		// Forms:
		const forms = document.querySelectorAll( '.content-body-wrap form, .content-custom-wrap form, .event-form form' )

		Array.from( forms ).forEach( ( form ) => {
			form.addEventListener( 'submit', this.handleFormSubmit )

			urlParams.forEach( ( value, key ) => {
				const field = form.querySelector( `#${key}` )

				if ( field && value ) {
					field.value = value
				}
			} )
		})

		// Recaptchas:
		const recaptchas = document.querySelectorAll( '.page-section .frm-g-recaptcha, .content-custom-wrap .frm-g-recaptcha' )

		Array.from( recaptchas ).forEach( ( recaptcha ) => {
			if ( 'undefined' != typeof grecaptcha ) {
				let recaptchaID = grecaptcha.render( recaptcha, {
					'sitekey': recaptcha.getAttribute( 'data-sitekey' )
				} )
				recaptcha.setAttribute( 'data-rid', recaptchaID )
				recaptcha.classList.remove( 'frm-g-recaptcha' )
			}
		})

		// Accordions:
		const accordionTitles = document.querySelectorAll( '.accordion-title' )

		Array.from( accordionTitles ).forEach( ( accordionTitle ) => {
			accordionTitle.addEventListener( 'click', this.handleAccordionTitleClick )
		})
	}

	handleLinkClick = ( e ) => {
		const { history } = this.props
		let href = e.currentTarget.getAttribute( 'href' ).replace( /^(\.+)/g, '' ),
			linkHostname = getHostname( href ),
			isFullUrl = href.indexOf( '//' ) > -1,
			isPartOfSite = linkHostname.indexOf( siteHostname ) > -1,
			isSubDomainOfSite = isPartOfSite && siteHostname.indexOf( linkHostname ) === -1,
			isThisSite = isPartOfSite && ! isSubDomainOfSite

		if ( href.indexOf( 'mailto:' ) > -1 ) {
			return // Email link, allow normal behaviour.
		} else if ( /^(?=.*\.[^\/.]+$).*/.test( href ) ) {
			window.open( href, '_blank' ) // File with extension, in new tab.
		} else if ( isSubDomainOfSite && isFullUrl ) {
			window.location = href // Subdomain, open normally.
		} else if ( ! isPartOfSite && isFullUrl ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 )
			window.location.hash = hash // Hash, jump.
		} else {
			// Get the path:
			let re = new RegExp( `^(?:https?:\/\/${siteData.site_domain})(.*)`, 'g' ),
				match = re.exec( href ),
				path = match && match[1] ? match[1] : href

			history.push( path ) // Same site, use router.
		}

		e.preventDefault()
	}

	handleFormSubmit = ( e ) => {
		const form = e.currentTarget
		const action = form.getAttribute( 'action' )
		const buttons = form.querySelectorAll( 'button' )
		const formData = new FormData( form )
		const submitUrl = action ? action : siteData.ajax_url

		if ( ! action ) {
			formData.append( 'action', 'ffm_formidable_submit_form' )
		}

		e.preventDefault()

		// disable the button
		if ( buttons.length ) {
			buttons[0].setAttribute( 'disabled', 'disabled' )
		}

		form.classList.remove( 'is-successful' )
		form.classList.add( 'is-processing' )

		// submit
		axios.post( submitUrl, formData )
		.then( response => {
			// success

			form.classList.remove( 'has-error' )
			form.setAttribute( 'data-message', '' )

			form.classList.remove( 'is-processing' )
			form.classList.add( 'is-processed' )

			// add a delay for UX
			setTimeout( () => {
				form.classList.remove( 'is-processed' )
				form.classList.add( 'is-successful' )

				// set the success message
				form.setAttribute( 'data-message', response.data )

				setTimeout( () => {
					form.classList.remove( 'is-successful' )

					// enable the button
					if ( buttons.length ) {
						buttons[0].removeAttribute( 'disabled', 'disabled' )
					}

					// clear form
					form.reset()
				}, 1000 )
			}, 1000 )
		})
		.catch( error => {
			// error

			form.classList.remove( 'is-processing' )
			form.classList.add( 'is-processed' )

			// add a delay for UX
			setTimeout( () => {
				form.classList.remove( 'is-processed' )
				form.classList.add( 'is-unsuccessful' )

				// set the error text
				form.classList.add( 'has-error' )
				error.response && form.setAttribute( 'data-message', error.response.data )

				setTimeout( () => {
					form.classList.remove( 'is-unsuccessful' )

					// enable the button
					if ( buttons.length ) {
						buttons[0].removeAttribute( 'disabled', 'disabled' )
					}
				}, 3000 )
			}, 1000 )
		})
	}

	handleAccordionTitleClick = ( e ) => {
		e.preventDefault()

		let section = e.currentTarget.parentNode

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
		} else {
			section.classList.add( 'is-closing' )
			section.classList.remove( 'is-active' )
			section.classList.remove( 'is-target' )

			setTimeout( () => {
				section.classList.remove( 'is-closing' )
				section.classList.add( 'is-not-active' )
			}, 750 )
		}
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		isMobile: state.site.isMobile,
		scrollTopButtonVisibility: state.site.scrollTopButtonVisibility
	}
}

export default withRouter(
	connect( mapStateToProps )( PageEvents )
)
